import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IConfigurationComision } from "src/models/General/Configuration.models";

interface configurationComisionstate {
  configurationComisions: IConfigurationComision[];
  configurationComisionToEdit: IConfigurationComision | null;
}

const initialState: configurationComisionstate = {
  configurationComisions: [],
  configurationComisionToEdit: null,
};

const configurationComisionSlice = createSlice({
  name: "ConfigurationComision",
  initialState,
  reducers: {
    setConfigurationComisionList: (state, action: PayloadAction<IConfigurationComision[]>) => {
      state.configurationComisions = action.payload;
    },
    concatListConfigurationComision: (
      state: configurationComisionstate,
      action: PayloadAction<IConfigurationComision[]>
    ) => {
      state.configurationComisions = [...state.configurationComisions.concat(action.payload)];
    },
    setConfigurationComisionToEdit: (state, action: PayloadAction<IConfigurationComision | null>) => {
      state.configurationComisionToEdit = action.payload;
    },
    addConfigurationComision: (state, action: PayloadAction<IConfigurationComision>) => {
      state.configurationComisions.push(action.payload);
    },
    updateConfigurationComision: (state, action: PayloadAction<IConfigurationComision>) => {
      let itemIndex = state.configurationComisions.findIndex(
        item => item.comisionId === action.payload.comisionId
      );
      if (itemIndex !== -1) state.configurationComisions[itemIndex] = action.payload;
    },
    deleteConfigurationComision: (state, action: PayloadAction<number>) => {
      const newArray = state.configurationComisions.filter(
        item => item.comisionId !== action.payload
      );
      state.configurationComisions = newArray;
    },
  },
});

export const {
  setConfigurationComisionList,
  concatListConfigurationComision,
  setConfigurationComisionToEdit,
  addConfigurationComision,
  updateConfigurationComision,
  deleteConfigurationComision,
} = configurationComisionSlice.actions;

export default configurationComisionSlice.reducer;
